import ouiBase from '@goldwasserexchange/oui';
import { useGetFieldPath } from '../fieldPath/hooks';

export function useFieldContent() {
  const fieldPath = useGetFieldPath();
  const state = ouiBase.Form.useFieldValueByPath(fieldPath);
  return state;
}
